import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: '#111' }}>
      <div className="mx-footer-inner">
        <a href="/" style={{ display: 'block', lineHeight: 0 }}>
          <img src="/assets/momorox-lockup.png" alt="MomoroX" style={{ height: '26px', width: 'auto', display: 'block' }} />
        </a>
        <div className="mx-footer-links">
          <Link to="/privacy" style={{ font: '400 12px "IBM Plex Mono",monospace', color: 'rgba(243,249,233,.45)', textDecoration: 'none' }}>Privacy</Link>
          <Link to="/terms" style={{ font: '400 12px "IBM Plex Mono",monospace', color: 'rgba(243,249,233,.45)', textDecoration: 'none' }}>Terms</Link>
          <Link to="/baa" style={{ font: '400 12px "IBM Plex Mono",monospace', color: 'rgba(243,249,233,.45)', textDecoration: 'none' }}>BAA</Link>
          <span style={{ font: '400 12px "IBM Plex Mono",monospace', color: 'rgba(243,249,233,.45)' }}>
            © {new Date().getFullYear()} · nick@momorox.com
          </span>
        </div>
      </div>
    </footer>
  );
}
